export default "<div class=\"phoenix\">\r\n  <lib-toast-notification></lib-toast-notification>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n";